import { createRouter, createWebHistory } from 'vue-router'
import store from '@/store/index'
import Home from '../views/Home.vue'


const routes = [
  { 
    path: "/:pathMatch(.*)", 
    name: "PageNotFound",
    component: () => import(/* webpackChunkName: "PageNotFound" */ '../views/PageNotFound.vue')
  },
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  // Deep Tagging
  {
    path: '/demos/sticker-tagging',
    name: 'StickerTagging',
    component: () => import(/* webpackChunkName: "StickerTagging" */ '../views/demos/stickerTagging/StickerTagging.vue'),
  },
  // Deep Tagging
  {
    path: '/demos/deep-tagging',
    name: 'DeepTagging',
    component: () => import(/* webpackChunkName: "DeepTagging" */ '../views/demos/deepTagging/DeepTagging.vue'),
  },
  // Deep Lens
  {
    path: '/demos/deep-lens',
    name: 'DeepLens',
    component: () => import(/* webpackChunkName: "DeepLens" */ '../views/demos/deepLens/DeepLens.vue')
  },
  // Landmark
  {
    path: '/demos/landmark',
    name: 'Landmark',
    component: () => import(/* webpackChunkName: "Landmark" */ '../views/demos/landmark/Landmark.vue')
  },
  // Logo
  {
    path: '/demos/logo',
    name: 'Logo',
    component: () => import(/* webpackChunkName: "Logo" */ '../views/demos/logo/Logo.vue')
  },
  // Face Lens
  {
    path: '/demos/face-lens',
    name: 'FaceLens',
    component: () => import(/* webpackChunkName: "FaceLens" */ '../views/demos/faceLens/FaceLens.vue')
  },
  // Fire Lens
  {
    path: '/demos/fire-lens',
    name: 'FireLens',
    component: () => import(/* webpackChunkName: "FireLens" */ '../views/demos/fireLens/FireLens.vue')
  },
  // Leak Lens
  {
    path: '/demos/leak-lens',
    name: 'LeakLens',
    component: () => import(/* webpackChunkName: "LeakLens" */ '../views/demos/leakLens/LeakLens.vue')
  },
  // Safety Lens
  {
    path: '/demos/safety-lens',
    name: 'SafetyLens',
    component: () => import(/* webpackChunkName: "SafetyLens" */ '../views/demos/safetyLens/SafetyLens.vue')
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.beforeEach(() => {
  store.commit('toggleSidebar', false)
})
router.afterEach(() => {
  document.documentElement.scrollTop = document.body.scrollTop = 0
})

export default router
